module.exports = "/_next/static/images/Frame2Mobile-6a7eab711edce38d42d5f691cb6f72e5.png";